import { TableBody } from "@mui/material";

import { useAppPalette } from "../../theme";
import { TableColumn, TableRow } from "./types";
import { Row } from "./Row";
import { RowCheckboxState } from "./useSelection";

interface BodyProps<TRow> {
    visibleRows: TableRow<TRow>[];
    columns: TableColumn<TRow>[];
    rowCheckboxByKey: Map<string | number, RowCheckboxState>;
    hasSelection: boolean;
    onRowClick?: (row: TableRow<TRow>) => void;
    onRowNavigatePath?: (row: TableRow<TRow>) => string | undefined;
    isRowDisabled?: (row: TableRow<TRow>) => boolean;
}

/** Flat-mode `<TableBody>`. Mounted when `grouping` is undefined. */
export function Body<TRow>({
    visibleRows,
    columns,
    rowCheckboxByKey,
    hasSelection,
    onRowClick,
    onRowNavigatePath,
    isRowDisabled
}: BodyProps<TRow>) {
    const { divider, hoverBackground } = useAppPalette();

    return (
        <TableBody>
            {visibleRows.map((row, i) => (
                <Row<TRow>
                    key={row.key}
                    row={row}
                    rowIndex={i}
                    columns={columns}
                    checkbox={hasSelection ? rowCheckboxByKey.get(row.key) : undefined}
                    onRowClick={onRowClick}
                    onRowNavigatePath={onRowNavigatePath}
                    isDisabled={isRowDisabled?.(row)}
                    divider={divider}
                    hoverBackground={hoverBackground}
                />
            ))}
        </TableBody>
    );
}
